import { render, staticRenderFns } from "./StatsDetaillees.vue?vue&type=template&id=5d589e41&"
import script from "./StatsDetaillees.vue?vue&type=script&lang=js&"
export * from "./StatsDetaillees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports